import { useCallback } from 'react';
import { useSelectedPolygonBoundsOnMap, useSelectedPolygonId } from 'state/map';

/**
 * Handles resetting of map selections.
 */
export const useResetMapSelections = () => {
  const [, setSelectedPolygonBoundsOnMap] = useSelectedPolygonBoundsOnMap();
  const [, setSelectedPolygon] = useSelectedPolygonId();

  const resetAllMapSelections = useCallback(() => {
    setSelectedPolygonBoundsOnMap('');
    setSelectedPolygon('');
  }, []);

  return {
    resetAllMapSelections,
  };
};
